var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('img',{class:_vm.b('logo'),attrs:{"src":_vm.$projectConfig.COMPANY_LOGO}}),(_vm.bankLogo)?[_c('span',{class:_vm.b('plus-icon')},[_vm._v("+")]),(_vm.bankLogo)?_c('img',{class:_vm.b('bank-logo'),attrs:{"src":_vm.bankLogo}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }